module.exports = __webpack_public_path__ + "media/images/bank_images/sudameris-4cf8d7b63b1cec12377d6d604df2ff07.png";